export function mobileMedicalDataRequirements(): {
  id: string;
  value: string;
}[] {
  return [
    { id: 'storageEncryption', value: 'Lagring er kryptert' },
    {
      id: 'networkEncryption',
      value: 'Kommunikasjon med internt nettverk er kryptert',
    },
    { id: 'strongAuthentication', value: 'Bruker sterk autentisering' },
    {
      id: 'firewallConfiguration',
      value: 'Kan bare kommunisere med predefinert utstyr',
    },
    {
      id: 'accessPointLogged',
      value: 'Tilkoblingspunkt logges kontinuerlig',
    },
    { id: 'antitheftMarking', value: 'Tyverimerket' },
    { id: 'printBlocked', value: 'Sperret for utskrift' },
    {
      id: 'externalStorageBlocked',
      value: 'Sperret for eksterne lagringsenheter',
    },
    {
      id: 'communicationPortsBlocked',
      value: 'Kommunikasjonsporter er sperret',
    },
    { id: 'secureStorage', value: 'Sikker oppbevaring' },
    { id: 'noPrivateUse', value: 'Brukes ikke privat' },
  ];
}
